import NotFound from './pages/NotFound';
import App from './App';
import KnowledgeBase from './components/KnowledgeBase/KnowledgeBase';
import StartScreen from './components/StartScreen/StartScreen';
import ErrorPage from './components/ErrorPage/ErrorPage';
import LogPage from './components/LogPage';

export default [{
  ...App,
  routes: [
    {
      path: '/KnowledgeBase',
      component: KnowledgeBase,
    },
    {
      path: '/StartScreen',
      component: StartScreen,
    },
    {  
      path: '/ErrorPage',
      component: ErrorPage,
    },
    {
      path: '/LogPage',
      component: LogPage,
    },
    {
      ...NotFound,
    },
  ],
}];
